import React from 'react';
import pluralize from 'pluralize';
import PropTypes from 'prop-types';
import ProgressBar from '@src/components/ProgressBar';
import { MIN_SLOTS_COUNT } from '@src/constants';

const PALETTE = {
  '0-100': 'subscription-modal__slots-progress--blue',
};

export const SlotsUsageProgress = ({ slotsInUse, openingSlots }) => {
  openingSlots = openingSlots || MIN_SLOTS_COUNT;

  return (
    <ProgressBar
      className="subscription-modal__slots-progress"
      maxValue={openingSlots}
      palette={PALETTE}
      thickness="medium"
      value={slotsInUse || 0}
    >
      <p className="subscription-modal__slots-progress-label">
        {`Using ${slotsInUse} of ${openingSlots} ${pluralize('slots', openingSlots)}`}
      </p>
    </ProgressBar>
  );
};

SlotsUsageProgress.propTypes = {
  openingSlots: PropTypes.number.isRequired,
  slotsInUse: PropTypes.number.isRequired,
};
